export default __webpack_public_path__ + "static/media/lotus.95e1a703.svg";